<template>
    <div v-else>
        <v-row no-gutters class="text-end">
            <v-col>
                <v-btn icon @click="resetNewShop()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="" no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Shop name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="shop.name"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateShopField($event, 'name')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Type" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="shop.type"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateShopField($event, 'type')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Comment" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="shop.comment"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateShopField($event, 'comment')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Address" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="shop.address"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateShopField($event, 'address')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "City" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="shop.address_place"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateShopField($event, 'address_place')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Parish" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="shop.address_parish"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateShopField($event, 'address_parish')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "County" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="shop.address_county"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateShopField($event, 'address_county')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col cols="6">
                <v-autocomplete
                    :value="shop.address_country"
                    @change="updateShopField($event, 'address_country')"
                    :items="countries"
                    :loading="isLoading"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    hide-no-data
                    hide-selected
                    :item-text="
                        item =>
                            (item.name_et ? item.name_et : null) +
                            (item.name_en ? item.name_en : null) +
                            ' (' +
                            item.code +
                            ')'
                    "
                    item-value="code"
                    outlined
                    :placeholder="t('Start typing to Search')"
                >
                    <template slot="selection" slot-scope="{ item, selected }">
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                    <template slot="item" slot-scope="{ item, tile }">
                        <country-flag :country="item.code" size="small" class="mr-1" />
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col :cols="1">
                <country-flag
                    v-if="shop.address_country"
                    :country="shop.address_country"
                    class="mt-0 ml-1"
                    size="normal"
                />
            </v-col>
        </v-row>
        <store-view />
    </div>
</template>

<script>
import StoreView from "./store-view";
import Store from "@/store";
import { mapState, mapActions } from "vuex";
import CountryFlag from "vue-country-flag";

export default {
    name: "shop-view",
    components: { StoreView, CountryFlag },
    data() {
        return {
            isLoading: false
        };
    },
    computed: {
        ...mapState("UnmatchedShopsStore", ["shop"]),
        ...mapState(["countries"])
    },
    methods: {
        updateShopField(value, field) {
            Store.commit("UnmatchedShopsStore/updateNewShopProperty", {
                prop: field,
                value: value
            });
        },
        resetNewShop() {
            Store.commit("UnmatchedShopsStore/resetNewShopData");
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}
</style>
